import { render, staticRenderFns } from "./guideDiet.vue?vue&type=template&id=516d22cb&scoped=true&"
import script from "./guideDiet.vue?vue&type=script&lang=js&"
export * from "./guideDiet.vue?vue&type=script&lang=js&"
import style0 from "./guideDiet.vue?vue&type=style&index=0&id=516d22cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516d22cb",
  null
  
)

export default component.exports